import Cover from '../../components/Cover/Cover';
import './BlogPage.css'

const BlogPage = ({ article }) => {
    const {metaTitle, metaDescription, coverImage, coverImageMobile, coverTitle, textsArr, imagesArr } = article;

    const isMobile = window.innerWidth <= 1199;
  const coverImageToUse = isMobile ? coverImageMobile : coverImage;

  return (
    <div className='page'>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription}/>
        <Cover text={coverTitle} src={coverImageToUse} />
        <div className="blog__page-texts">
            {
                textsArr.map((text, idx) => {
                    return (
                            <p key={idx} className="blog__page-text mont-r">{text}</p>
                    )
                } )
            }
        </div>
        <div className="blog__page-images">
            {
                imagesArr.map((image, idx) => {
                    return (
                            <img key={idx} src={image} alt={`картинка блогу номер ${idx + 1}`} className="blog__page-image" />
                    )
                } )
            }
        </div>
    </div>
  )
}

export default BlogPage